export const keycloackLoginError = [
  {
    path: '/erro-login',
    name: 'login-error',
    component: () => import('@/views/conclusion/GenericServiceDesk.vue'),
    meta: {
      header: {
        title: 'Login',
        hidePreviousBtn: true,
      },
      publicRoute: true,
      disabledPageReloadGuard: true,
      body: {
        title: 'Ocorreu um problema no seu login',
        subtitle: 'você precisará ser atendido em um guichê na unidade.',
        btnLabel: 'Ok, entendi'
      }
    },
  },
];
